/* ------------------------------------------------------------------------ */
/*		File: cmpSkill.tsx                                                  */
/*		Description: Component Implementation                               */
/*		Project: iSymWebSchool											    */
/*		Author: ISym Global Solutions Limited                               */
/*		Version: 1.0													    */
/* ------------------------------------------------------------------------ */


import React from "react";
import { ICmpSkill } from "./cmpSkill.d";
import { getImage } from "../../components/GenericComponents/functions";
import "./cmpSkill.css"

/* ------------------------------------------------------------------------ */

const Skill: React.FC<ICmpSkill> = (props) => {
    return (
        <div className="card_skill">
            <img className="card_skill_image" src={getImage(props.src)} alt={props.src} />
            <div className="card_skill_label">{props.label}</div>
            <img className="card_skill_icon" src={getImage(props.status)} alt={props.status} />
        </div>
    );
};

export default Skill; 